import React from "react";
import { Navigate } from "react-router-dom";

const ProtectedRoute = ({ children }) => {
    const isAuthenticated = isAuthenticatedFunction();

    return isAuthenticated ? children : <Navigate to="/" replace />;
};

const isAuthenticatedFunction = () => {
    let token = localStorage.getItem("zajednica-token");
    if (!token) {
        return;
    };

    try {
        const payload = JSON.parse(atob(token.split(".")[1]));
        return payload.exp * 1000 > Date.now();
    } catch (error) {
        return false;
    }
};

export default ProtectedRoute;